import { useNavigate } from 'react-router-dom';
import './css/Hero2.css'

export default function HeroSection2() {
  const navigate = useNavigate()
  return (
    <section className="about-section">
      {/* <img
        src="https://themesflat.co/html/restaurant/basilicohtml/assets/images/section/menu10.png"
        alt="Left Dish"
        className="about-img left-img"
      /> */}
      
      <div className="about-content">
  <h3 className="section-subtitle">ABOUT LIN'S BISTRO</h3>
  <h2 className="section-title">EXPERIENCE THE FINEST CHINESE & THAI CUISINE</h2>
  <p className="description">
    At Lin's Bistro, we take pride in offering a unique dining experience that brings together the rich flavors of Chinese and Thai cuisine. From savory stir-fries to aromatic curries, our dishes are crafted with the freshest ingredients to create a perfect harmony of taste and tradition.
  </p>
  <p className="description">
    Our warm and inviting atmosphere makes Lin's Bistro the perfect place for family dinners, celebrations, or simply enjoying a meal with friends. Pair your meal with our curated selection of beverages for a complete culinary journey. Whether you dine in, take out, or order delivery, we promise a meal to remember.
  </p>
  <button className="about-btn" onClick={() => navigate('/order')}>Order Now</button>
</div>


      {/* <img
        src="https://themesflat.co/html/restaurant/basilicohtml/assets/images/section/menu11.png"
        alt="Right Dish"
        className="about-img right-img"
      /> */}
    </section>
  );
}
